var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandscapeCardCarousel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 815 253",
    width: 815,
    height: 253,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 815,
    height: 253,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAy8AAAD9AQMAAACP/drKAAAAAXNSR0IB2cksfwAAAAZQTFRFcnJyAAAAoanOvQAAAAJ0Uk5T/wDltzBKAAAAkUlEQVR4nO3NMRWAMBBEwbsqdLGAkyAdpMQBJXQxcAJSzLb/vZ2MeuOO5ypLf2OeZWlf/Ed9lxgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBrMxswBlne9JxUyu+AAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 3",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeCardCarousel);
export default __webpack_public_path__ + "static/media/Landscape_Card_Carousel.03f517f1c79bde8b48968f186655ad04.svg";
export { ForwardRef as ReactComponent };